module.exports = __webpack_public_path__ + "static/media/getsitecontrol-logo.f2b70891.png";